import { ClientDataType } from 'modules/queryBuilder/types';
import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

/**
 * Hook to capture certain events based on feature flag.
 * If the events aren't feature flagged we return those events to filter out
 */

const isNotFeatureFlagged = (isFeatureFlagged: boolean) => isFeatureFlagged === false;

export const useNonFeatureFlaggedEvents = (flag: string, eventsToFilter: ClientDataType[]) => {
  const isFeatureFlagged = useFeatureFlag(flag, false);
  return isNotFeatureFlagged(isFeatureFlagged) ? eventsToFilter : [];
};
